
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feedback",
      function () {
        return require("private-next-pages/feedback.tsx");
      }
    ]);
  